import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import packageJson from "../../package.json";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const fetchCompany = createAsyncThunk(
  'Company/fetchCompany',
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await axios.get(`${BaseUrl}/getAllCompanies` ,{
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
          'Content-Type': 'application/json'
        },
       });
      const result = await res.data.data;
      return result;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        // localStorage.removeItem("isLoggedIn");
        // window.location.reload()
      }
      return rejectWithValue(error.message);
    }
  }
  
);



const CompanySlice = createSlice({
  name: 'Company',
  initialState: { Companies: [], loading: false, error: null },

    reducers: {
      clearCompany: (state) => {
        state.Companies = [];
        state.loading = false;
        state.error = null;
      },
    },
  
  extraReducers: {
    //fetch
    [fetchCompany.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchCompany.fulfilled]: (state, action) => {
      state.Companies = action.payload;
      state.loading = false;
    },
    [fetchCompany.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});
export const { clearCompany } = CompanySlice.actions;

export default CompanySlice.reducer;
